import type { Action } from './actions';

export type State = {
  isShow: boolean;
  scrolled: boolean;
  isError: boolean;
  inited: boolean;
  timeoutInit: boolean;
};

export const initialState: State = {
  isShow: false,
  isError: false,
  scrolled: false,
  inited: false,
  timeoutInit: false,
};

export function reducer(state: State, action: Action) {
  switch (action.type) {
    case 'is-show':
      return {
        ...state,
        isShow: action.payload.isShow,
      };
    case 'scrolled':
      return {
        ...state,
        scrolled: action.payload.scrolled,
      };
    case 'error':
      return {
        ...state,
        isError: true,
      };
    case 'inited':
      return {
        ...state,
        inited: true,
      };
    case 'timeout-init':
      return {
        ...state,
        timeoutInit: true,
      };
    default:
      return state;
  }
}
